import { Route, Routes } from 'react-router-dom'
import PageHeader from 'components/AppBar/PageHeader'
import { BasePathProvider, useSession } from 'components/Providers'
import { Box, Paper } from '@mui/material'
import AssignAsset from './MyDevice'
import NoAccess from 'components/NoAccess'
import NotFound from 'components/NotFound'
import NeedsAttentionIndex from './NeedsAttention'
import AssetTabs, { tabConfig } from './Tabs'
import RedirectToFirstPermitted from 'components/RedirectToPermittedTab'
import AddDeviceIndex from './AddDevice'
import { useDispatch } from 'react-redux'
import { getCampus } from 'store/lookup'
import { useEffect } from 'react'

export default function AssetManagement() {
    const basePath = '/asset-management'
    const { permissions, district } = useSession()
    const dispatch = useDispatch();
    
    useEffect(() => {
        dispatch(getCampus())
    }, [dispatch, district?.id])

    return (
        <BasePathProvider value={`${basePath}/`}>
            <Box sx={{ mb: 2 }}>
                <PageHeader title={'Device Management'} />
            </Box>
            <Paper sx={{ width: '100%', minHeight: '500px', p: 2, mb: 2 }}>
                {permissions['miscellaneous.device'] ? (
                    <>
                        <AssetTabs />
                        <Routes>
                            <Route path="/">
                                <Route index element={<RedirectToFirstPermitted basePath={basePath} items={tabConfig} />} />
                                <Route path="" element={<AssignAsset />} />
                                <Route path="my-devices/*" element={<AssignAsset />} />
                                <Route path="needs-attention/*" element={<NeedsAttentionIndex />} />
                                {district?.isServiceProvider && (
                                    <Route path="add-devices/*" element={<AddDeviceIndex />} />
                                )}
                                <Route path="*" element={<NotFound />} />
                            </Route>
                        </Routes>
                    </>
                ) : <NoAccess />}
            </Paper>

        </BasePathProvider>
    )
}
